import { getPlugin as getTranslationPlugin } from '@i18n/utils'

import translations from '../../components/TrustList/TrustList.translations'

export const deliveryItem = () => {
  const $t = getTranslationPlugin()

  return {
    id: 'reassurance_service_delivery',
    text: $t(translations.delivery),
    icon: 'IconSecured',
  }
}
